import { DEVICE_TABLE_TYPE } from '@/shared/config';
import classNames from 'classnames';
import _ from 'lodash';
import { DevicesTable } from '@/widgets/devices-table';
import { useDevicesTableWithSubTab } from './useDevicesTableWithSubTab';
import SegmentedGroup from '../segmentedGroup';
import type { DevicesTableWithSubTabProps } from './devicesTableWithSubTab.types';

/**
 * Renders a devices table together with the segmented sub-tab filter that narrows it. Shows the segmented control only for the all-devices and unused tabs, then renders one devices table per filter option with all but the selected one hidden, forwarding its own props plus the resolved sub-tab type, the isUnused flag and an isActive flag that also requires the option to be the selected filter.
 *
 * @param props - Table props including the tab type and active flag.
 * @returns The sub-tabbed devices table markup.
 */
const DevicesTableWithSubTab = (props: DevicesTableWithSubTabProps) => {
  const { filterAllDeviceList, filterUnusedDeviceList, filterDevice, onClickFilterDevice } =
    useDevicesTableWithSubTab(props);

  const isUnused = props.type === DEVICE_TABLE_TYPE.UNUSED_DEVICES_TAB;

  return (
    <div className="devices-table-with-subtab-container">
      {(props.type === DEVICE_TABLE_TYPE.ALL_DEVICES_TAB || isUnused) && (
        <div className="filter-device" id="filter-device">
          <SegmentedGroup
            options={isUnused ? filterUnusedDeviceList.current : filterAllDeviceList.current}
            value={filterDevice}
            onChange={onClickFilterDevice}
          />
        </div>
      )}
      {_.map(isUnused ? filterUnusedDeviceList.current : filterAllDeviceList.current, (item) => (
        <div className={classNames(filterDevice === item.value ? '' : 'hidden')} id={item.id}>
          <DevicesTable
            {...{
              ...props,
              ...{
                isActive: props.isActive && filterDevice === item.value,
                type: item.value,
                isUnused,
              },
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default DevicesTableWithSubTab;
